/**
 * Whether the new sign-in is switched on (the `new-sign-in` flag's Everyone
 * setting, from GET Account/sign-in-settings). Kept here, with no imports, so
 * the axios instance can read it without pulling in React or the API helpers.
 * Off until the settings have loaded, and off when they fail to load.
 */
let newSignIn = false;

export const isNewSignInOn = (): boolean => newSignIn;

export const setNewSignIn = (on: boolean): void => {
  newSignIn = on;
};
